'use client'

import ProductCard from '../../../entities/ProductCard'
import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions'
import {
    useGetCartItemsQuery,
    useProductsCatalogMutation,
} from '@/shared/api-rtk'
// import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

export function Latest({ onMount }) {
    const [getData, { error }] = useProductsCatalogMutation()
    // const { items: itemsFavorite } = useSelector((state) => state.favorite)
    // const { isAuth } = useSelector((state) => state.authUser)
    const [data, setData] = useState([])

    const { data: productsInCart, isLoading, refetch } = useGetCartItemsQuery()
    useEffect(() => {
        if (data.length) return
        getData()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    const result = Object.values(res.data).sort(
                        (a, b) =>
                            new Date(b.date_available) -
                            new Date(a.date_available)
                    )
                    setData(Object.values(result))
                    refetch()
                }
            })
            .finally(() => {
                setTimeout(() => onMount(), 500)
            })
    }, [data?.length, refetch])

    console.log(data)

    return (
        <div className={'LatestContainer'}>
            <h1>Новинки</h1>
            <div className="items-container">
                {data?.map((item) => {
                    return (
                        <ProductCard {...item} key={item.product_id}>
                            <QuickView
                                productId={item.product_id}
                                item={item}
                            />
                            <AddToPreferences
                                item={item}
                                productId={item.product_id}
                            />
                            <AddToCart
                                item={item}
                                productId={item.product_id}
                                cartContains={productsInCart?.data?.includes(
                                    item.product_id
                                )}
                            />
                        </ProductCard>
                    )
                })}
                {error && <span>Ошибка сервера, перезагрузите страницу</span>}
            </div>
        </div>
    )
}
